import React from 'react';

// components
import CardsListItemWebinar from './CardsListItemWebinar';

// types
import { ICardsListProps } from './types';

// styles
import { Wrapper } from './styles';

export const CardsListWebinar = ({
  type,
  data,
  clickAction,
}: ICardsListProps) => {
  return (
    <Wrapper>
      {data &&
        data.map((item, index) => (
          <CardsListItemWebinar
            key={index}
            type={type}
            data={item}
            clickAction={clickAction}
          />
        ))}
    </Wrapper>
  );
};

export default CardsListWebinar;
